module.exports = __webpack_public_path__ + "static/heart_unfilled-f28db8a0c4b7b87cb68ff8c2a8660edd.svg";